import {
  Accordion,
  borderRadius,
  ButtonGroup,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Title = styled.div`
  ${typographyV2.titleMd};
`;

export const DrawerTitle = styled.h2`
  ${typographyV2.titleLg};
  color: var(--text-default);
`;

export const ContentWrapper = styled.div`
  padding: 20px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledAccordion = styled(Accordion)`
  ${Accordion.Styled.IconStyled} {
    fill: var(--icon-default);
  }
  ${Accordion.Styled.TitleContent} {
    ${typographyV2.titleBase}
    color: var(--text-default);
  }
  ${Accordion.Styled.Content} {
    ${typographyV2.bodySm}
    color: var(--text-default);
  }
  ${Accordion.Styled.AccordionItem} {
    margin-bottom: 8px;
  }
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  ${borderRadius.r3}
  border: 1px solid var(--border-soft);
  background: var(--background-soft);
  display: flex;
  padding: 4px;
  margin-bottom: 20px;
  ${ButtonGroup.Styles.ButtonGroupItem} {
    ${borderRadius.r2}
  }
`;
